import styled from 'styled-components';
import Typography from '../../typography';

const navSize = 60;
export const headerHeight = 56;
export const topOffset = navSize + headerHeight;
export const drawerScrollHeight = `calc(100vh - ${topOffset}px)`;

export const virtualStyle: React.CSSProperties = {
  overflowY: 'auto',
  height: drawerScrollHeight,
  contain: 'strict',
  padding: 0,
};

export const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  min-height: 56px;

  background: ${({ theme }) => theme.color.surface.background};

  .ui-drawer-close-btn {
    margin: 0;
    margin-right: 8px;
    width: 48px;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    background: none;
    outline: none;
    border: none;
  }

  .ui-drawer-title {
    flex: 1;
    padding-left: 24px;
    ${({ theme }) => theme.mappedTypography.h5.default};
    color: ${({ theme }) => theme.color.tint.primary};

    &:not(.close-btn) {
      padding-right: 24px;
    }
  }
`;

export const DrawerTitle = styled(Typography).attrs((p) => ({ ...p, display: 'h4' }))`
  margin-bottom: ${({ theme }) => theme.spacings.component.S}px;
`;
export const DrawerDescription = styled(Typography).attrs((p) => ({ ...p, display: 'body2' }))`
  margin-bottom: ${({ theme }) => theme.spacings.component.S}px;
  color: ${({ theme }) => theme.color.tint.secondary};
`;
